import React from 'react';
import { reportsApi, authApi } from '../../../../api/client';

/**
 * ExportButtons — triggers a server-side render of CSV or PDF for the
 * current report + range + filters. The download relies on the browser
 * following the Content-Disposition: attachment header from the API.
 *
 * 2026-08-10: the download is a raw <a> navigation, which does NOT go through
 * the api() helper's on-401 refresh+retry. If the short-lived cx_access cookie
 * had expired, the new-tab navigation returned {"detail":"missing_token"}
 * intermittently. Fix: proactively REFRESH the session (mint a fresh
 * cx_access cookie) right before navigating, so the cookie is always valid
 * when the browser follows the export URL. Best-effort: if refresh fails we
 * still attempt the download (the server will 401 and the user can retry).
 */
export default function ExportButtons({ report, params, disabled }) {
  const download = async (format) => {
    const url = reportsApi.downloadUrl(report, params, format);
    try { await authApi.refresh(); } catch (_) { /* best-effort */ }
    // Use a hidden anchor so cookies (cx_access) ride along automatically.
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => document.body.removeChild(a), 200);
  };

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        disabled={disabled}
        onClick={() => download('csv')}
        title="Download CSV"
        className="px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle disabled:opacity-40 disabled:cursor-not-allowed"
      >
        ↓ CSV
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => download('pdf')}
        title="Download PDF"
        className="px-2 py-1 text-xs rounded-thin border border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle disabled:opacity-40 disabled:cursor-not-allowed"
      >
        ↓ PDF
      </button>
    </div>
  );
}
